<template>
  <div id="login">
    <g-signin-button
      :params="googleSignInParams"
      @success="onSignInSuccess"
      @error="onSignInError">
      Sign in with Google
    </g-signin-button>
  </div>
</template>

<script>

import {isLoggedIn, attemptLogIn} from '../util/auth';

export default {
  name: 'login',
  data () {
    return {
      googleSignInParams: {
        client_id: '1027062249723-4qpght8p42fd88an4usq4cpvfgu3t1el.apps.googleusercontent.com'
      }
    }
  },
  methods: {
    onSignInSuccess (googleUser) {
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users
      // https://developers.google.com/identity/sign-in/web/backend-auth
      // "Warning: Do not accept plain user IDs, such as those you can get with the GoogleUser.getId() method, on your backend server."
      const id_token = googleUser.getAuthResponse().id_token;
      console.log(`Token: ${id_token}`)
      attemptLogIn(id_token).then(() => {
        this.$router.push('/');
      }).catch((e) => {console.error(e.message)})
    },
    onSignInError (error) {
      // `error` contains any error occurred.
      console.log('OH NOES', error);
      alert(`Google sign-in error: ${error.error}`);
    }
  }
}
</script>

<style scoped>
#login {
  padding: 10px 10px 10px 10px;
}

.g-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #3c82f7;
  color: #fff;
  box-shadow: 0 3px 0 #0f69ff;
  cursor: pointer;
  cursor: hand;
}

</style>


// WEBPACK FOOTER //
// Login.vue?559ff234